module.exports = __webpack_public_path__ + "static/media/custom-master.8ef99751.jpeg";